import React from 'react';
import {
    ClusterNumberFieldEdit,
} from '@domain/dashboard/cluster/campaign-table-cluster-components/cluster-number-field-edit';
import { CLUSTER_FIELDS_FUNCTIONS } from '@domain/dashboard/cluster/cluster.constants';
import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';

interface Props {
    value: number
    row: any
}

export const DaysBetweenAdjustmentsTargetEdit = ({
    value,
    row,
}: Props) => (
    <ClusterNumberFieldEdit
        row={row}
        value={value}
        key={CLUSTER_FIELDS_FUNCTIONS.daysBetweenAdjustmentsTarget.field}
        field={CLUSTER_FIELDS_FUNCTIONS.daysBetweenAdjustmentsTarget.field}
        type={METRICS_TYPES.integer}
        precision={0}
    />
);
